import { RefundPaymentDto } from '../dtos/refund-payment.dto';
import { PaymentItem } from '../models/payment-item';
import { RefundPayment } from '../models/refund-payment';
import { activeMapper } from './active.mapper';
import { cardMapper } from './card.mapper';
import { dateMapper } from './date.mapper';

/**
 * Map object from dto.
 * @param {object} dto DTO.
 * @returns {PaymentItem}
 */
function fromDto(dto) {
  return new PaymentItem({
    isActive: activeMapper.fromDto(dto.active),
    amount: dto.amount,
    approveDate: dateMapper.fromDto(dto.approve_date),
    checkNumber: dto.check_number,
    createDate: dateMapper.fromDto(dto.create_date),
    creditCard: dto.credit_card != null ? cardMapper.fromDto(dto.credit_card) : null,
    editDate: dateMapper.fromDto(dto.edit_date),
    id: dto.id,
    isCheckType: dto.is_check_type,
    name: dto.name,
    refId: dto.ref_id,
    transactionId: dto.transaction_id,
    type: dto.type ? {
      code: dto.type.code,
      id: dto.type.id,
      name: dto.type.name,
    } : null,
    typeId: dto.type_id,
    userId: dto.user_id,
  });
}

/**
 * Map refund payment from dto
 * @param {RefundPaymentDto} dto Refund payment dto.
 * @returns {RefundPayment}
 */
function refundPaymentFromDto(dto) {
  return new RefundPayment({
    id: dto.id,
  });
}

export const paymentItemMapper = {
  fromDto,
  refundPaymentFromDto,
};
